import React from 'react';

// Variant for Cobalt's own Practice Insights setup: a practice connects its
// own EHR, so there is no third-party vendor to name, and the current Cobalt
// mark is shown. Sent by the embedding page in the init message (variant).
export const PRACTICE_INSIGHTS = 'practice_insights';

// The current Cobalt mark (same drawing as cobalt-app CobaltMark).
export function CobaltMark({ size = 40 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 240 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect width="240" height="240" rx="44" fill="#576dee" />
      <text
        x="26"
        y="46"
        fontWeight="500"
        fontSize="22"
        fill="#ffffff"
        letterSpacing="1.5"
        style={{ fontFamily: 'ui-monospace, monospace' }}
      >
        27
      </text>
      <text
        x="120"
        y="175"
        fontWeight="600"
        fontSize="148"
        fill="#ffffff"
        textAnchor="middle"
        letterSpacing="-5"
        style={{ fontFamily: 'Georgia, serif' }}
      >
        Co
      </text>
    </svg>
  );
}

// Mark plus "Practice Insights", for the practice variant's headers.
export function PracticeLockup({ size = 28 }) {
  return (
    <span className="cobalt-inline-flex cobalt-items-center cobalt-gap-2">
      <CobaltMark size={size} />
      <span className="cobalt-font-semibold cobalt-text-gray-900">
        Practice Insights
      </span>
    </span>
  );
}

// The "cobalt" wordmark (same paths as cobalt-app CobaltWordmark).
export function CobaltWordmark({ height = 18 }) {
  return (
    <svg
      viewBox="250 310 530 150"
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="cobalt"
      role="img"
      style={{ display: 'block', color: '#576dee' }}
    >
      <g transform="matrix(1.3892 0 0 1.3892 299.4205 404.7016)">
        {' '}
        <path
          fill="currentColor"
          transform="translate(-358.9911, -398.9142)"
          d="M 348.65 430.54 C 344.5614 428.8564 340.954 426.3312 337.707 423.2047 C 334.5805 420.0781 332.1755 416.3504 330.3718 412.2617 C 328.6883 408.0529 327.7263 403.6037 327.7263 398.9137 C 327.7263 394.3442 328.6883 389.8949 330.3718 385.5657 C 332.1755 381.5974 334.5805 377.8697 337.707 374.7437 C 340.9538 371.6171 344.5613 369.0919 348.65 367.4084 C 352.8587 365.6046 357.4283 364.6426 361.998 364.6426 C 367.5295 364.6426 373.181 366.0857 377.991 368.6109 C 382.801 371.1362 386.8896 374.8639 390.016 379.1929 L 375.345 389.6549 C 372.2184 385.326 367.2882 382.6804 361.997 382.6804 C 353.0984 382.6804 345.763 390.0157 345.763 398.9144 C 345.763 407.9332 353.0982 415.1484 361.997 415.1484 C 367.4082 415.1484 372.338 412.5028 375.345 408.1738 L 390.256 418.3948 C 383.8826 427.6541 373.301 433.1858 361.997 433.1858 C 357.4276 433.1858 352.858 432.3441 348.649 430.5404 Z"
        />{' '}
      </g>
      <g transform="matrix(1.3892 0 0 1.3892 395.5205 404.5347)">
        {' '}
        <path
          fill="currentColor"
          transform="translate(-428.1676, -398.7941)"
          d="M 414.82 430.42 C 410.7314 428.7364 407.0033 426.2112 403.877 423.0847 C 400.7506 419.9582 398.2252 416.2304 396.5418 412.1417 C 394.7381 407.9329 393.8961 403.4837 393.8961 398.7937 C 393.8961 394.2241 394.738 389.7749 396.5418 385.4457 C 398.2253 381.4775 400.7506 377.7497 403.877 374.6237 C 407.0034 371.4971 410.7315 368.972 414.82 367.2884 C 419.0284 365.4847 423.4778 364.5227 428.168 364.5227 C 432.7372 364.5227 437.1866 365.4847 441.516 367.2884 C 445.4839 368.972 449.212 371.4971 452.338 374.6237 C 455.4644 377.7502 457.9897 381.3577 459.6732 385.4457 C 461.4769 389.7747 462.4391 394.224 462.4391 398.7937 C 462.4391 403.4835 461.4769 407.9326 459.6732 412.1417 C 457.9897 416.2302 455.4644 419.958 452.338 423.0847 C 449.2116 426.2112 445.6042 428.7365 441.516 430.42 C 437.1869 432.2237 432.7375 433.0655 428.168 433.0655 C 423.478 433.0655 419.0286 432.2238 414.82 430.42 Z M 428.168 415.028 C 437.0664 415.028 444.402 407.813 444.402 398.794 C 444.402 389.8954 437.0668 382.56 428.168 382.56 C 419.1489 382.56 411.934 389.8953 411.934 398.794 C 411.934 407.8128 419.1489 415.028 428.168 415.028 Z"
        />{' '}
      </g>
      <g transform="matrix(1.3892 0 0 1.3892 503.6783 383.6509)">
        {' '}
        <path
          fill="currentColor"
          transform="translate(-506.0239, -383.7611)"
          d="M 537.65 412.14 C 535.8463 416.2285 533.4413 419.9563 530.3147 423.083 C 527.068 426.2095 523.4605 428.6146 519.3717 430.4183 C 515.163 432.222 510.5934 433.0638 506.0237 433.0638 C 501.4541 433.0638 496.8847 432.2221 492.6757 430.4183 C 488.5871 428.7347 484.9797 426.2095 481.7327 423.083 C 478.6062 419.9565 476.2012 416.2287 474.3975 412.14 C 472.7139 407.9312 471.7519 403.482 471.7519 398.792 L 471.7519 340.471 L 489.7899 334.4584 L 489.7899 368.6094 C 490.7519 368.1284 491.7139 367.6474 492.6759 367.2867 C 496.8846 365.483 501.4541 364.521 506.0239 364.521 C 510.7136 364.521 515.1629 365.483 519.3719 367.2867 C 523.4605 368.9703 527.1882 371.3752 530.3149 374.622 C 533.4415 377.7484 535.8465 381.356 537.6502 385.444 C 539.4539 389.6527 540.2958 394.2223 540.2958 398.792 C 540.2958 403.4817 539.454 407.9309 537.6502 412.14 Z M 506.024 415.026 C 514.9225 415.026 522.258 407.811 522.258 398.792 C 522.258 389.8934 514.9227 382.558 506.024 382.558 C 497.1254 382.558 489.79 389.8933 489.79 398.792 C 489.79 407.8108 497.1252 415.026 506.024 415.026 Z"
        />{' '}
      </g>
      <g transform="matrix(1.3892 0 0 1.3892 605.3334 404.6963)">
        {' '}
        <path
          fill="currentColor"
          transform="translate(-579.1991, -398.9103)"
          d="M 613.05 432.34 L 595.012 432.34 L 595.012 429.5743 C 590.3223 431.9792 584.911 433.1818 579.62 433.1818 C 574.9302 433.1818 570.481 432.3401 566.272 430.5363 C 562.1834 428.8527 558.4557 426.3275 555.329 423.201 C 552.2025 420.0744 549.6772 416.3467 547.9938 412.258 C 546.19 408.0492 545.3482 403.6 545.3482 398.91 C 545.3482 394.3405 546.19 389.8912 547.9938 385.562 C 549.6773 381.4735 552.2025 377.866 555.329 374.74 C 558.4555 371.6134 562.1832 369.0882 566.272 367.4047 C 570.4807 365.6009 574.93 364.6389 579.62 364.6389 C 585.0313 364.6389 590.322 365.9617 595.012 368.3667 L 595.012 364.6389 L 613.05 364.6389 Z M 579.62 415.144 C 582.506 415.144 585.2718 414.4224 587.797 412.9794 C 590.202 411.5364 592.2463 409.4921 593.569 407.0871 C 595.012 404.6821 595.7335 401.7961 595.7335 399.0303 C 595.7335 396.505 595.2525 394.2203 594.2905 392.0558 C 592.9677 389.29 590.9235 387.0052 588.3983 385.3218 C 585.7527 383.6382 582.7465 382.6762 579.62 382.6762 C 570.6012 382.6762 563.386 390.0115 563.386 398.9102 C 563.386 407.929 570.601 415.1442 579.62 415.1442 Z"
        />{' '}
      </g>
      <g transform="matrix(1.3892 0 0 1.3892 682.7144 383.8175)">
        {' '}
        <path
          fill="currentColor"
          transform="translate(-634.901, -383.881)"
          d="M 643.98 335.42 L 643.98 432.342 L 625.822 432.342 L 625.822 341.433 Z"
        />{' '}
      </g>
      <g transform="matrix(1.3892 0 0 1.3892 742.1583 390.5044)">
        {' '}
        <path
          fill="currentColor"
          transform="translate(-677.691, -388.6945)"
          d="M 696.27 415.51 L 696.27 433.548 C 691.22 433.548 686.4098 432.586 681.84 430.662 C 677.391 428.8583 673.4223 426.0925 670.055 422.7255 C 666.5674 419.3585 663.9222 415.3902 661.9986 410.9405 C 660.0742 406.371 659.112 401.4407 659.112 396.3905 L 659.112 349.8535 L 677.15 343.841 L 677.15 365.366 L 696.269 365.366 L 696.269 382.201 L 677.15 382.201 L 677.15 396.39 C 677.15 406.972 685.6875 415.51 696.269 415.51 Z"
        />{' '}
      </g>
    </svg>
  );
}

// Mark plus wordmark: the Cobalt logo.
export function CobaltLockup({ size = 24 }) {
  return (
    <span
      className="cobalt-inline-flex cobalt-items-center cobalt-gap-2"
      aria-label="Cobalt"
    >
      <CobaltMark size={size} />
      <CobaltWordmark height={Math.round(size * 0.7)} />
    </span>
  );
}

// Header logo: the Practice Insights lockup in the practice variant, the
// Cobalt lockup for everyone else.
export function HeaderLogo({ variant, size = 24 }) {
  if (variant === PRACTICE_INSIGHTS) return <PracticeLockup size={size} />;
  return <CobaltLockup size={size} />;
}
